import React from "react";
import DailyBreadContainer from "../../containers/DailyBread/DailyBreadContainer";
import { Helmet } from "react-helmet";

const DailyBread = () => {
  return (
    <>
      <Helmet>
        <title>อ่านพลังประจำวัน - Scripture Union Thailand</title>
        <meta
          name="description"
          content="SU THAILAND ทำพันธกิจร่วมกับคริสตจักรและโรงเรียน เพื่อให้เด็กเยาวชนและครอบครัว ได้ยินข่าวประเสริฐของพระเจ้า"
        />
      </Helmet>
      <DailyBreadContainer />
    </>
  );
};

export default DailyBread;
